import Vue from 'vue';
import 'vuetify/dist/vuetify.min.css';
import { ResourceConfig } from '@witkac/kartamiejska-resources';

import { apolloClient } from './apollo';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import loaderService from './services/loader.service';
import store from './store';
import { checkIfOnline } from './utils/connection';

// Rejestracja Service-Workera
// import './registerServiceWorker';


Vue.config.productionTip = false;

ResourceConfig.setApollo(apolloClient);
ResourceConfig.setLoader(loaderService);

checkIfOnline();

new (Vue as any)({
  router,
  store,
  vuetify,
  render: (h: any) => h(App)
}).$mount('#app');
